// filter.enum.ts
export var Filter;
(function (Filter) {
    Filter["ALL"] = "all";
    Filter["ACTIVE"] = "active";
    Filter["COMPLETED"] = "completed";
})(Filter || (Filter = {}));
